<template>
    <div>
        <breadcrumb :items="breadcrumbs"></breadcrumb>
        <v-card color="transparent" flat>
            <v-toolbar color="transparent" flat>
                <v-toolbar-title class="font-weight-bold text-wrap">{{ $t('geneticsAndBreeding.animalsWithExpectedProgenyDifferences')}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <!-- <v-btn color="primary" class="mr-2" @click="$router.push({name: 'GeneticSearch'})">{{ $t('geneticsAndBreeding.geneticSearchTool')}}</v-btn> -->
                <v-menu bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" v-bind="attrs" v-on="on">
                            {{ $t("geneticsAndBreeding.dataSubmission") }}
                            <v-icon>mdi-chevron-down</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="dataSubType=true">
                            <v-list-item-title>
                                {{ $t("geneticsAndBreeding.individualEntry") }}
                            </v-list-item-title>
                        </v-list-item>
                        <!-- <v-list-item @click="uploadGenetic()"> -->
                        <v-list-item>
                            <!-- <v-list-item-avatar style="margin: 0px">
                            <v-icon> mdi-import </v-icon>
                            <v-img
                                style="background-size: unset"
                                src="/img/upload_user.svg"
                            ></v-img>
                            </v-list-item-avatar> -->
                            <v-list-item-title>
                                {{ $t("geneticsAndBreeding.bulkEntry") }}
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-toolbar>
            <v-card-text>
                <router-view></router-view>
            </v-card-text>
        </v-card>


        <v-dialog
            v-model="dataSubType"
            persistent
            max-width="750"
        >
        <v-card class="pb-5">
            <v-toolbar flat class="white--text" color="secondary">
                <v-toolbar-title>{{ $t('selectOption') }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="dataSubType=false"><v-icon class="white--text">mdi-close</v-icon></v-btn>
            </v-toolbar>
            <v-card-text class="pt-5" style="text-align: center; color: #000">
                {{ $t('geneticsAndBreeding.registerANewAnimalOrSelectAnExistingAnimal') }}
            </v-card-text>
            <v-card-actions  style="text-align: center;display: block;">
                <v-btn
                    color="green darken-1"
                    outlined
                    @click="$router.push({ name: 'AddAnimal' })"
                >
                {{ $t('geneticsAndBreeding.registerNewAnimal') }}
                
                </v-btn>
                <v-btn
                    depressed
                    color="primary"
                    @click="$router.push({ name: $route.name == 'GeneticsListV2' ? 'GeneticsDataSubmission' : 'GeneticsDataSubmission' })"
                >
                {{ $t('geneticsAndBreeding.selectExistingAnimal')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <ConfirmBox
      :title="texts.confirm.title"
      :message="texts.confirm.message"
      :cancelBtnText="texts.confirm.cancel"
      :confirmBtnText="texts.confirm.confirm"
      :confirmData="texts.confirm.confirmData"
      :dialog="confirm"
      @confirm:action="goToBulkUploadStatusPage"
    />
    <upload-genetics
      :dialogI="showUploadGenetics"
      @closeUploadGenetics="closeUploadGenetics"
    ></upload-genetics>
    </div>
</template>

<script>
import UploadGenetics from "@/views/genetics/UploadGenetics";
import ConfirmBox from "@/components/ConfirmBox";

export default {
    mounted(){
        document.title = this.$t('geneticsAndBreeding.geneticsAndBreeding')
    },
    components: {
        UploadGenetics,
        ConfirmBox
    },
    data() {
        return {
            dataSubType: false,
            breadcrumbs: [
                {
                    text: this.$t('dashboard'),
                    disabled: false,
                    to: "/",
                },
                {
                    text: this.$t('geneticsAndBreeding.geneticsAndBreeding'),
                    disabled: true,
                    to: { name: "Genetics" },
                },
            ],
            texts: {
                confirm: {
                    title: "Bulk Upload Queued",
                    message: "Your uploaded file is currently being processed. You can monitor the progress by checking the \"Manage Bulk Animals\" menu. We will notify you via email as soon as the system has completed processing your file.",
                    cancel: "Close",
                    confirm: "Manage Bulk Animals",
                    confirmData: {}
                }
            },
            confirm: false,
            showUploadGenetics: false,
        }
    },
    methods: {
        closeUploadGenetics(success) {
            if (success === true) {
                this.confirm = true;
            }
            this.showUploadGenetics = false;
        },
        uploadGenetic() {
            this.showUploadGenetics = true;
        },
        goToBulkUploadStatusPage(action) {
            if (action) {
                this.$router.push({
                    name: "bulkUploadStatus"
                });
            }

            this.confirm = false;
        }
    },
}
</script>
